module.exports = __webpack_public_path__ + "img/icon-qr-qq-wechat.5d82191e.png";